import type { TopScorerState } from './models';
import { reducer } from './models';

import { zustandStoreFactory } from '@shared/zustandStoreFactory';

export type { TopScorerState };

export const {
  Provider: TopScorerProvider,
  useStore: useTopScorerStore,
  createStore: createTopScorerStore,
} = zustandStoreFactory<TopScorerState>(reducer, 'TopScorer');
